<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>{{ nodeName ? 'Suggest an Improvement' : 'Make a Suggestion' }}</h3>
            <div v-if="nodeName" style="margin-bottom:10px">For <b>{{ nodeName }}</b></div>
            <textarea v-model="formData.text" style="height:220px" />
            <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'ProcessSuggestionForm',
    // nodeName: the playbook page it was opened from (Playbook.vue), sent along so admins know what it's about
    // slug: that page's slug, so the Forge can draft the change for a reviewer (AIHub / Review)
    props: [ 'nodeName', 'slug' ],
    data() {
        return {
            disableButton: false,
            formData: {
                text: ''
            },
        }
    },
    methods: {
        async submit() {
            if(!this.formData.text) {
                return;
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/processsuggestions`, { ...this.formData, nodeName: this.nodeName || null, slug: this.slug || null })
                .then(resp => {
                    alert('Thanks for your suggestion!')
                    this.$emit('close');
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })

            this.disableButton = false;
        },
    }
});
</script>
